export const aboutData = {
    title: "Full Stack Web Developer",
    description1: "My name's Amarjeet Maurya . I'm a web designer and developer based in India, Mumbai.",
    description2: "Tech-savvy Full Stack Web Developer proficient in fundamental front-end languages and server-side languages. In-depth knowledge of HTML, CSS and JavaScript. Eager to contribute to team success through hard work, attention to detail and excellent organizational skills. Motivated to learn, grow and excel in software industry.",
    image: 1
}